<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { billingService } from '@/services/billing';

const router = useRouter();
const isLoading = ref(true);
const walletBalance = ref<any>({});

onMounted(async () => {
  try {
    const orgData = await billingService.getOrgDetails();
    walletBalance.value = orgData.wallets;
  } catch (error) {
    console.error("Failed to refresh wallet", error);
  } finally {
    isLoading.value = false;

    const returnTarget = sessionStorage.getItem('billingReturnTarget');
    if (returnTarget === 'form') {
      sessionStorage.removeItem('billingReturnTarget');
      setTimeout(() => {
        router.push('/?billing=success');
      }, 1500);
      return;
    }

    setTimeout(() => {
      router.push('/billing');
    }, 5000);
  }
});
</script>

<template>
  <div class="success-page">
    <div class="card">
      <div class="icon">🎉</div>
      <h1>Payment successful!</h1>
      <p>Thank you for your purchase. Your tokens have been added to your wallet.</p>

      <div v-if="!isLoading" class="balance-preview">
        <p>Current Balance:</p>
        <div class="amount">
          {{ Object.values(walletBalance).reduce((acc: number, src: any) => acc + (src.purchased || 0) + (src.subscription || 0), 0) }} tokens
        </div>
      </div>

      <button @click="router.push('/billing')">Back to Billing</button>
    </div>
  </div>
</template>

<style scoped>
.success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
  font-family: var(--font-sans);
  background: var(--vt-c-background-primary, var(--color-background));
}

.card {
  background: rgba(var(--vt-c-accent-rgb), 0.06);
  border: 1px solid rgba(var(--vt-c-accent-rgb), 0.12);
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  backdrop-filter: blur(12px);
}

.icon {
  font-size: 4rem;
  margin-bottom: 20px;
}

h1 {
  color: var(--color-heading, #fff);
  margin-bottom: 10px;
  font-weight: 800;
}

p {
  color: var(--color-text-soft, rgba(255, 255, 255, 0.65));
  margin-bottom: 30px;
  line-height: 1.5;
}

.balance-preview {
  background: rgba(var(--vt-c-accent-rgb), 0.08);
  border: 1px solid rgba(var(--vt-c-accent-rgb), 0.15);
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.balance-preview p {
  margin: 0 0 5px 0;
  font-size: 0.9rem;
  color: var(--color-text-soft, rgba(255, 255, 255, 0.65));
}

.amount {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--vt-c-accent, var(--vt-c-accent));
}

button {
  background: var(--vt-c-accent, var(--vt-c-accent));
  color: var(--vt-c-background-primary, var(--color-background));
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  font-size: 0.95rem;
}

button:hover {
  background: var(--vt-c-accent-dark, var(--vt-c-accent-dark));
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(var(--vt-c-accent-rgb), 0.25);
}
</style>
